var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWcCancelDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62124 3.93589C4.62124 3.56853 4.91858 3.27119 5.28594 3.27119C5.41654 3.27119 5.54458 3.30972 5.65553 3.38323L5.65595 3.38351L9.68082 6.06719L10.666 5.43662L6.24875 2.4913L6.24827 2.49098C5.96322 2.30181 5.6293 2.2 5.28594 2.2C4.32698 2.2 3.55005 2.97692 3.55005 3.93589V9.99109L4.62124 9.30549V3.93589ZM4.62124 11.3239L3.55005 12.0095V13.8539C3.55005 14.1957 3.65041 14.5313 3.84216 14.8174C4.37401 15.614 5.45073 15.8303 6.24857 15.2983L6.24872 15.2982L13.6874 10.3398L13.6875 10.3398C13.8767 10.2136 14.041 10.0506 14.1686 9.8586C14.7004 9.06104 14.4851 7.98329 13.6876 7.4513L13.6875 7.45128L13.6875 7.45125L12.2105 6.46646L11.2253 7.09703L13.0931 8.34244C13.3986 8.54617 13.481 8.95899 13.2773 9.26448L13.2769 9.265L13.2766 9.26553C13.229 9.33727 13.1666 9.39962 13.0933 9.4485L13.0933 9.44852L5.65445 14.4069L5.65437 14.407L5.6543 14.407C5.3493 14.6105 4.93691 14.5282 4.73287 14.2223L4.73249 14.2217L4.7321 14.2212C4.66 14.1137 4.62124 13.9861 4.62124 13.8539V11.3239Z",
    fill: "#111111"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 12.92,
    width: 15.6199,
    height: 1,
    rx: 0.5,
    transform: "rotate(-32.6238 1.5 12.92)",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcCancelDark);
export default __webpack_public_path__ + "static/media/wc-cancel-dark.a8f49aa3f0df0ed08b67fc248ae73587.svg";
export { ForwardRef as ReactComponent };